import React from "react";


export default function RadioButtonHolder(props) {
	return (
		<div className={`radio_buttons auto_matchmaking_toggle ranked_slot_selectors active ${props.className}`}>
			{props.children}
		</div>
	);
}